/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Tooltip,
} from "reactstrap";

//Components that mount the conversation filters card
import ConversationFilterCardInput from "../../../../../../../../../../Common/ConversationFilterCardInput";

import "./ConversationFilterCard.scss";

import { withTranslation } from "react-i18next";
import { getTabsBySkill } from "../../../../../../../../../../../store/manager/actions.js";

const ConversationFilterCard = ({
  t,
  setFilterCustom,
  optionData,
  toggle,
  loadingData,
  filterCustom,
  onClearDatePicker,
  handleDatePicker,
  handleFilter,
}) => {
  const wrapperRef = useRef("");

  const { errorConversation, loadingConversation } = useSelector(
    (state) => state.Manager
  );
  const [dropdownFilter, setDropdownFilter] = useState(false);
  const [dropdownMailFilter, setDropdownMailFilter] = useState(false);
  const [dropdownCheckbox, setDropdownCheckbox] = useState([]);
  const [dropdownCheckboxEmail, setDropdownCheckboxEmail] = useState([
    "document",
    "phone",
    "email",
  ]);
  const [originalFirstLevelTabs, setOriginalFirstLevelTabs] = useState([]);
  const [originalSecondLevelTabs, setOriginalSecondLevelTabs] = useState([]);
  const [originalThirdLevelTabs, setOriginalThirdLevelTabs] = useState([]);
  const [firstLevelTabs, setFirstLevelTabs] = useState([]);
  const [secondLevelTabs, setSecondLevelTabs] = useState([]);
  const [thirdLevelTabs, setThirdLevelTabs] = useState([]);
  const [selectedFirstLevelTab, setSelectedFirstLevelTab] = useState([]);
  const [selectedSecondLevelTab, setSelectedSecondLevelTab] = useState([]);
  const [selectedThirdLevelTab, setSelectedThirdLevelTab] = useState([]);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const { mainTheme } = useSelector((state) => state.Layout);

  const tabs = useSelector((state) => {
    return state?.Manager?.tabs;
  });

  const dispatch = useDispatch();

  useEffect(() => {
    const localFirstLevelTabs = [];
    const localSecondLevelTabs = [];
    const localThirdLevelTabs = [];
    if (tabs?.length > 0) {
      tabs.forEach((tab) => {
        localFirstLevelTabs.push({
          value: tab?.id,
          label: tab?.name,
          skillId: tab?.skill_id,
          global: tab?.global,
        });
        if (tab?.children) {
          if (tab?.children?.length > 0) {
            tab.children.forEach((firstChildTab) => {
              localSecondLevelTabs.push({
                value: firstChildTab?.id,
                fatherId: tab.id,
                label: firstChildTab?.name,
                skillId: firstChildTab?.skill_id,
                global: firstChildTab?.global,
              });
              if (firstChildTab?.children?.length > 0) {
                firstChildTab.children.forEach((secondChildTab) => {
                  localThirdLevelTabs.push({
                    value: secondChildTab?.id,
                    grandfatherId: firstChildTab?.id,
                    label: secondChildTab?.name,
                    skillId: secondChildTab?.skill_id,
                    global: secondChildTab?.global,
                  });
                });
              }
            });
          }
        }
      });
    }
    setFirstLevelTabs(localFirstLevelTabs);
    setSecondLevelTabs(localSecondLevelTabs);
    setThirdLevelTabs(localThirdLevelTabs);
    setOriginalFirstLevelTabs(localFirstLevelTabs);
    setOriginalSecondLevelTabs(localSecondLevelTabs);
    setOriginalThirdLevelTabs(localThirdLevelTabs);
  }, [tabs]);

  const optionStatus = () => {
    return optionData?.status.map((element) => ({
      value: element,
      label: t(element).toUpperCase(),
    }));
  };

  const optionSkill = () => {
    return optionData?.skills.map((element) => ({
      value: element.id,
      label: element.name,
    }));
  };

  const optionAgent = () => {
    return optionData?.users.map((element) => ({
      value: element.id,
      label: element.name,
    }));
  };

  const toggleDropdownFilter = () => {
    setDropdownFilter((prev) => !prev);
  };

  const toggleDropdownFilterEmail = () => {
    setDropdownMailFilter((prev) => !prev);
  };

  useEffect(() => {
    /**
     * CloseMenu if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        toggle();
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  // Transform this to array
  useEffect(() => {
    setDropdownCheckbox(optionData?.filtersExtra);
  }, []);

  useEffect(() => {
    setFilterCustom({
      ...filterCustom,
      extrasFilters: dropdownCheckbox,
    });
  }, [dropdownCheckbox]);

  useEffect(() => {
    setFilterCustom({
      ...filterCustom,
      personalInformationFilters: dropdownCheckboxEmail,
    });
  }, [dropdownCheckboxEmail]);

  useEffect(() => {
    const filteredSecondLevelTabs = [];
    secondLevelTabs.forEach((secondLevelTab) => {
      if (selectedFirstLevelTab !== null) {
        selectedFirstLevelTab.forEach((selectedTab) => {
          if (secondLevelTab?.fatherId === selectedTab?.value) {
            filteredSecondLevelTabs.push(secondLevelTab);
          }
        });
      }
    });
    if (selectedFirstLevelTab === null) {
      setSecondLevelTabs(originalSecondLevelTabs);
      setFilterCustom({
        ...filterCustom,
        tabs: [],
      });
    } else {
      setSecondLevelTabs(filteredSecondLevelTabs);
    }
  }, [selectedFirstLevelTab]);

  useEffect(() => {
    const filteredThirdLevelTabs = [];
    thirdLevelTabs.forEach((thirdLevelTab) => {
      if (selectedSecondLevelTab !== null) {
        selectedSecondLevelTab.forEach((selectedTab) => {
          if (thirdLevelTab?.grandfatherId === selectedTab?.value) {
            filteredThirdLevelTabs.push(thirdLevelTab);
          }
        });
      }
    });
    if (selectedSecondLevelTab === null) {
      const currentTabs = filterCustom?.tabs;
      if (currentTabs) {
        currentTabs.pop();
      }
      setThirdLevelTabs(originalThirdLevelTabs);
      setFilterCustom({
        ...filterCustom,
        tabs: currentTabs,
      });
    } else {
      setThirdLevelTabs(filteredThirdLevelTabs);
    }
  }, [selectedSecondLevelTab]);

  useEffect(() => {
    if (selectedThirdLevelTab === null) {
      const currentTabs = filterCustom?.tabs;
      if (currentTabs) {
        currentTabs.pop();
      }
      setFilterCustom({
        ...filterCustom,
        tabs: currentTabs,
      });
    }
  }, [selectedThirdLevelTab]);

  const filtersEmailDoc = ["document", "phone", "email"];

  const clearFilters = () => {
    setFilterCustom({});
    setSelectedFirstLevelTab([]);
    setSelectedSecondLevelTab([]);
    setSelectedThirdLevelTab([]);
  };

  return (
    <div id="filter-card-area" ref={wrapperRef} style={{ overflowY: "auto" }}>
      <Card id="filter-card" className="mb-0" style={{ overflowY: "auto" }}>
        <CardBody style={{ overflowY: "auto" }}>
          <h5 className="my-3">{t("Filter by")}:</h5>
          {loadingData ? (
            <div className="d-flex w-100 justify-content-center">
              {t("Loading...")}
            </div>
          ) : (
            <div style={{ overflowY: "auto" }}>
              <ConversationFilterCardInput
                filterCardInputTitle={t("Status")}
                filterCardInputPlaceholder={t("Select status")}
                addon
                select
                selectOptions={optionStatus()}
                onChange={(e) =>
                  setFilterCustom({
                    ...filterCustom,
                    status: e,
                  })
                }
                value={filterCustom?.status ?? null}
                isMulti
              />
              <ConversationFilterCardInput
                className="select2-selection"
                filterCardInputTitle={t("Skill")}
                filterCardInputPlaceholder={t("Select skill")}
                addon
                select
                selectOptions={optionSkill()}
                isMulti
                onChange={(e) => {
                  if (e === null) {
                    setSelectedFirstLevelTab(null);
                    setSelectedSecondLevelTab(null);
                    setSelectedThirdLevelTab(null);
                    setFilterCustom({
                      ...filterCustom,
                      skills: [],
                    });
                  } else {
                    if (e?.length > 0) {
                      dispatch(getTabsBySkill(e[e?.length - 1]?.value));
                      setFilterCustom({
                        ...filterCustom,
                        skills: e,
                      });
                    }
                  }
                }}
                value={filterCustom?.skills ?? null}
              />
              <Tooltip
                placement="top"
                isOpen={isTooltipOpen}
                target="onlyForTicketsTooltip"
                toggle={() => {
                  setIsTooltipOpen(!isTooltipOpen);
                }}
              >
                Apenas para tickets.
              </Tooltip>
              <div id="onlyForTicketsTooltip">
                <ConversationFilterCardInput
                  filterCardInputTitle={t("Tab")}
                  filterCardInputPlaceholder={
                    "Selecione uma tabulação (nível 1)"
                  }
                  addon
                  select
                  selectOptions={firstLevelTabs}
                  isMulti
                  onChange={(e) => {
                    if (e) {
                      if (e?.length === 1) {
                        setSelectedFirstLevelTab(e);
                        setFilterCustom({
                          ...filterCustom,
                          tabs: e,
                        });
                      }
                    } else {
                      setSelectedFirstLevelTab(e);
                      setSelectedSecondLevelTab(null);
                      setSelectedThirdLevelTab(null);
                    }
                  }}
                  value={selectedFirstLevelTab}
                />
                {selectedFirstLevelTab?.length > 0 && (
                  <ConversationFilterCardInput
                    filterCardInputTitle={""}
                    filterCardInputPlaceholder={
                      "Selecione uma tabulação (nível 2)"
                    }
                    addon
                    select
                    selectOptions={secondLevelTabs}
                    isMulti
                    onChange={(e) => {
                      if (e) {
                        if (e?.length === 1) {
                          setSelectedSecondLevelTab(e);
                          setFilterCustom({
                            ...filterCustom,
                            tabs: e.concat(...filterCustom?.tabs),
                          });
                        }
                      } else {
                        setSelectedSecondLevelTab(e);
                        setSelectedThirdLevelTab(null);
                      }
                    }}
                    value={selectedSecondLevelTab}
                  />
                )}
                {selectedSecondLevelTab?.length > 0 && (
                  <ConversationFilterCardInput
                    filterCardInputTitle={""}
                    filterCardInputPlaceholder={
                      "Selecione uma tabulação (nível 3)"
                    }
                    addon
                    select
                    selectOptions={thirdLevelTabs}
                    isMulti
                    onChange={(e) => {
                      setSelectedThirdLevelTab(e);
                      if (e) {
                        if (e?.length === 1) {
                          setSelectedThirdLevelTab(e);
                          setFilterCustom({
                            ...filterCustom,
                            tabs: e.concat(...filterCustom?.tabs),
                          });
                        }
                      } else {
                        setSelectedThirdLevelTab(e);
                      }
                    }}
                    value={selectedThirdLevelTab}
                  />
                )}
              </div>

              <ConversationFilterCardInput
                filterCardInputTitle={t("Agent")}
                filterCardInputPlaceholder={t("Select agent")}
                addon
                select
                selectOptions={optionAgent()}
                isMulti
                onChange={(e) =>
                  setFilterCustom({
                    ...filterCustom,
                    users: e,
                  })
                }
                value={filterCustom?.users ?? null}
              />
              <ConversationFilterCardInput
                filterCardInputTitle={t("Client")}
                filterCardInputPlaceholder={t("Enter client name")}
                addon
                onChange={(e) =>
                  setFilterCustom({
                    ...filterCustom,
                    consumer: e.target.value,
                  })
                }
                value={filterCustom?.consumer ?? ""}
              />
              <ConversationFilterCardInput
                filterCardInputTitle={t("Chat id")}
                filterCardInputPlaceholder={t("Enter chat id")}
                addon
                onChange={(e) =>
                  setFilterCustom({
                    ...filterCustom,
                    conversation_id: e.target.value,
                  })
                }
                value={filterCustom?.conversation_id ?? ""}
              />

              <ConversationFilterCardInput
                filterCardInputTitle={t("Protocol")}
                filterCardInputPlaceholder={t(
                  "Enter the Conversation or Ticket protocol"
                )}
                addon
                onChange={(e) =>
                  setFilterCustom({
                    ...filterCustom,
                    protocol: e.target.value,
                  })
                }
                value={filterCustom?.protocol ?? ""}
              />
              <ConversationFilterCardInput
                filterCardInputTitle={t("Message")}
                filterCardInputPlaceholder={t("Enter message")}
                addon
                onChange={(e) => {
                  var dateOffset = 24 * 60 * 60 * 1000 * 7; // 7 days
                  const now = new Date();
                  const sevenBefore = new Date(now.getTime() - dateOffset);
                  const aux = filterCustom?.date
                    ? { message: e.target.value }
                    : {
                        message: e.target.value,
                        date: [sevenBefore, now],
                      };
                  setFilterCustom({
                    ...filterCustom,
                    ...aux,
                  });
                }}
                value={filterCustom?.message ?? ""}
              />

              <div id="documentEmailFilter">
                <ButtonDropdown
                  id="buttonFilter"
                  className="form-group mt-4"
                  isOpen={dropdownMailFilter}
                  toggle={toggleDropdownFilterEmail}
                >
                  <DropdownToggle
                    caret
                    className="bx bx-filter-alt search-icon icon-button"
                    color="primary"
                  ></DropdownToggle>
                  <DropdownMenu top="true">
                    {filtersEmailDoc.map((e, idx) => (
                      <DropdownItem
                        key={`${e}${idx}`}
                        toggle={false}
                        onClick={() => {
                          setDropdownCheckboxEmail((prev) =>
                            prev.includes(e)
                              ? prev.filter((eRemove) => eRemove !== e)
                              : [...prev, e]
                          );
                        }}
                      >
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input pointer"
                            id="customControlInline"
                            disabled={true}
                            checked={
                              dropdownCheckboxEmail
                                ? dropdownCheckboxEmail.includes(e)
                                : false
                            }
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customControlInline"
                          >
                            {t(e)}
                          </label>
                        </div>
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </ButtonDropdown>
                <ConversationFilterCardInput
                  filterCardInputTitle={t("Personal inf")}
                  filterCardInputPlaceholder={t(
                    "Enter the personal information"
                  )}
                  addon
                  onChange={(e) => {
                    setFilterCustom({
                      ...filterCustom,
                      personalInformation: e.target.value,
                    });
                  }}
                  value={filterCustom?.personalInformation ?? ""}
                />
              </div>

              {optionData?.filtersExtra?.length > 0 && (
                <div id="extraFilter">
                  <ButtonDropdown
                    id="buttonFilter"
                    className="form-group mt-4"
                    isOpen={dropdownFilter}
                    toggle={toggleDropdownFilter}
                  >
                    <DropdownToggle
                      caret
                      className="bx bx-filter-alt search-icon icon-button"
                      color="primary"
                    ></DropdownToggle>
                    <DropdownMenu top="true">
                      {optionData?.filtersExtra?.length > 0 &&
                        optionData.filtersExtra.map((e, idx) => (
                          <DropdownItem
                            key={`${e}${idx}`}
                            toggle={false}
                            onClick={() => {
                              setDropdownCheckbox((prev) =>
                                prev.includes(e)
                                  ? prev.filter((eRemove) => eRemove !== e)
                                  : [...prev, e]
                              );
                            }}
                          >
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input pointer"
                                id="customControlInline"
                                disabled={true}
                                checked={
                                  dropdownCheckbox
                                    ? dropdownCheckbox.includes(e)
                                    : false
                                }
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="customControlInline"
                              >
                                {t(e)}
                              </label>
                            </div>
                          </DropdownItem>
                        ))}
                    </DropdownMenu>
                  </ButtonDropdown>
                  <ConversationFilterCardInput
                    filterCardInputTitle={t("Extra")}
                    filterCardInputPlaceholder={t("Enter extra info")}
                    addon
                    onChange={(e) => {
                      setFilterCustom({
                        ...filterCustom,
                        extras: e.target.value,
                      });
                    }}
                    value={filterCustom?.extras ?? ""}
                  />
                </div>
              )}
              <ConversationFilterCardInput
                filterCardInputTitle={t("Date")}
                filterCardInputPlaceholder={t("Select period")}
                addon
                datepicker
                onChange={handleDatePicker}
                value={filterCustom?.date ?? []}
                onClearDatePicker={onClearDatePicker}
              />
              <div className="text-danger mb-3">
                {Array.isArray(errorConversation) &&
                  errorConversation.map((e, key) => (
                    <div key={key}>{t(e?.value)}</div>
                  ))}
              </div>
              <div className="d-flex justify-content-between">
                <Button
                  id="clearButton"
                  className="btn btn waves-effect"
                  style={{
                    color: mainTheme === "dark" ? "#8092ec" : "black",
                  }}
                  onClick={() => {
                    clearFilters();
                  }}
                >
                  {t("Clear")}
                </Button>
                <Button
                  id="manager-filter-button"
                  className="waves-effect"
                  disabled={loadingConversation}
                  onClick={() => {
                    handleFilter();
                    selectedFirstLevelTab?.length > 0 && clearFilters();
                  }}
                >
                  {t("Apply filter")}
                </Button>
              </div>
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default withTranslation()(ConversationFilterCard);
